import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import G from './components/G';
import H from './components/H';
import getLocal from '@/app/utils/i18n';
import Sustainability from '@elem/compPage/PowerForAll/components/Sustainability';

export default function IndexDynamic() {
    const { locale = '' } = getLocal();
    return (
        <>
            <B />
            <C />
            <D />
            <E />
            {locale === 'cn' && <Sustainability />}
            {/* <F /> */}
            {['cn', 'jp', 'eu', 'de', 'fr', 'it', 'es', 'us', 'ca', 'za', 'au', 'uk', 'mx', 'nl'].includes(locale) && <H />}
            <G />
        </>
    );
}
